import { createReducer } from '@reduxjs/toolkit';
import { SiteDto } from '../../api/ClientApi';

import { saveSite, importSites, updateReduxSite } from '../actions/siteActions';
import { saveSiteOwners } from '../actions/siteOwnerFormActions';

export interface SitesReducerState {
    sites: SiteDto[] | null;
}

function clearState(state: SitesReducerState): void {
    state.sites = null;
}

function getInitialState(): SitesReducerState {
    const state: SitesReducerState = {
        sites: null,
    };

    clearState(state);

    return state;
}

export const sitesReducer = createReducer<SitesReducerState>(getInitialState(), (builder) => {
    builder
        .addCase(saveSite.fulfilled, (state: SitesReducerState, action: any) => {
            if (state.sites === null) {
                return;
            }

            const payload: SiteDto = action.payload;

            const site: SiteDto = new SiteDto();
            site.init(payload);

            const siteIndex = state.sites!.findIndex((a) => {
                return a.id === site.id;
            });

            if (siteIndex >= 0) {
                // update site
                state.sites.splice(siteIndex, 1, site);
            } else {
                // add site
                state.sites.unshift(site);
            }
        })
        .addCase(saveSiteOwners.fulfilled, (state: SitesReducerState, action: any) => {
            if (state.sites === null) {
                return;
            }

            const payload: SiteDto = action.payload;

            const site: SiteDto = new SiteDto();
            site.init(payload);

            const siteIndex = state.sites!.findIndex((a) => {
                return a.id === site.id;
            });

            if (siteIndex >= 0) {
                // update site
                state.sites.splice(siteIndex, 1, site);
            } else {
                // add site
                state.sites.unshift(site);
            }
        })
        .addCase(importSites.fulfilled, (state: SitesReducerState, action: any) => {
            const newSites = (action.payload ?? []) as SiteDto[];

            state.sites = newSites.sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
        })
        .addCase(updateReduxSite.fulfilled, (state: SitesReducerState, action: any) => {
            if (state.sites === null) {
                return;
            }

            const payload: SiteDto = action.payload;

            const site: SiteDto = new SiteDto();
            site.init(payload);

            const siteIndex = state.sites!.findIndex((a) => {
                return a.id === site.id;
            });

            if (siteIndex >= 0) {
                // update site
                state.sites.splice(siteIndex, 1, site);
            } else {
                // add site
                state.sites.unshift(site);
            }
        });
});
